import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { translator } from "../utils/translator";
import type { StudentProgress } from "../types/user";

const columnHelper = createColumnHelper<StudentProgress>();

export const StudentsProgressTableDef = ({
  onClick,
  progressFields,
}: {
  onClick: ({ studentId }: { studentId: number }) => void;
  progressFields: string[];
}): ColumnDef<StudentProgress, any>[] => [
  columnHelper.accessor("user_code", {
    cell: (info) => <span>{info.getValue()}</span>,
    header: "학생코드",
  }),
  columnHelper.accessor("name", {
    cell: (info) => <span>{info.getValue()}</span>,
    header: "이름",
  }),
  columnHelper.accessor("total_status", {
    cell: (info) => <span>{translator[info.getValue() || "empty"]}</span>,
    header: "상태",
  }),
  columnHelper.accessor("id", {
    header: "입력",
    cell: (info) => (
      <button onClick={() => onClick({ studentId: info.getValue() })}>
        점수입력
      </button>
    ),
  }),
  columnHelper.accessor("department", {
    cell: (info) => <span>{translator[info.getValue()]}</span>,
    header: "구분",
  }),
  columnHelper.accessor("course", {
    cell: (info) => <span>{translator[info.getValue()]}</span>,
    header: "과정",
  }),
  columnHelper.accessor("training_type", {
    cell: (info) => <span>{translator[info.getValue()]}</span>,
    header: "실습 유형",
  }),
  columnHelper.accessor("timetable", {
    cell: (info) => <span>{translator[info.getValue()]}</span>,
    header: "시간",
  }),
  columnHelper.group({
    header: "상세 점수",
    columns: progressFields.map((field: string) => ({
      header: translator[`progress_${field}`],
      cell: ({ row }) => {
        const { status, score_or_time } = row.original.progress[field];
        if (["training", "homework"].includes(field)) {
          return <span>{translator[status || "empty"]}</span>;
        }

        const display =
          !score_or_time && !status
            ? "-"
            : `${score_or_time || ""} ${translator[status] || ""}`;

        return <span>{display}</span>;
      },
    })),
  }),
];
